import { Component, OnInit } from '@angular/core';
import { BalanceQuery, config, MemberDetails, MemberQuery, TransactionType } from '@fgb/core';
import { Observable } from 'rxjs';
import { jetCashNavItems } from 'src/app/shared/utilities/navigation-pills-settings';

@Component({
  selector: 'fgb-ecash-history',
  templateUrl: './ecash-history.component.html',
  styleUrls: ['./ecash-history.component.scss'],
})
export class EcashHistoryPageComponent implements OnInit {
  transactionStartDate: Date;
  transactionEndDate: Date;
  transactionType: TransactionType;
  transactionTypes = TransactionType;
  jetCashNavItems = jetCashNavItems;

  memberDetails$: Observable<MemberDetails | undefined>;
  combinedCard$: Observable<number | undefined>;
  loyaltyPointsCard$: Observable<number | undefined>;

  constructor(private memberQuery: MemberQuery, private balanceQuery: BalanceQuery) {}
  memberId: string;
  ngOnInit() {
    this.memberId = this.memberQuery.getUserContext().memberId;
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.combinedCard$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    this.loyaltyPointsCard$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.transactionType = TransactionType.ecash;
    this.transactionEndDate = new Date();
    this.transactionStartDate = new Date();
    this.transactionStartDate.setDate(new Date(this.transactionStartDate).getDate() - 1);
  }
}
